"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateObject = exports.throwNotOk = exports.createShouldBeEqualTo = void 0;
const ValidationErrors_1 = require("./ValidationErrors");
const types_1 = require("./types");
function createShouldBeEqualTo(getter) {
    return (val) => getter() === val ? ValidationErrors_1.ValidationErrors.None : ValidationErrors_1.ValidationErrors.ShouldBeEqualTo;
}
exports.createShouldBeEqualTo = createShouldBeEqualTo;
function throwNotOk(result, message = 'Validation error') {
    if (result) {
        throw new types_1.ValidationError(message, result);
    }
}
exports.throwNotOk = throwNotOk;
function validateObject(obj, validators, onlyTruethy = false, context) {
    const res = {};
    Object.keys(obj).forEach(k => {
        const kk = k;
        const validator = validators[kk];
        if (!validator) {
            return;
        }
        const v = obj[k];
        if (onlyTruethy && !v) {
            return;
        }
        const err = validator(v, context || obj);
        if (err) {
            res[kk] = err;
        }
    });
    return res;
}
exports.validateObject = validateObject;
//# sourceMappingURL=helpers.js.map